/* ============
 * Transaction Type Transformer
 * ============
 *
 * The transformer for the organization type.
 */

import Transformer from './transformer';

export default class TransactionTypeTransformer extends Transformer {
  static fetch(transactionType) {
    return {
      id: transactionType.id,
      code: transactionType.code,
      description: transactionType.description,
      relations: transactionType.relations,
    };
  }

  static send(transactionType) {
    return {
      id: transactionType.id,
      code: transactionType.code,
      description: transactionType.description,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/transactionType.js